import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { TaxesAdapter } from './dto/taxes.adapter';
import { TaxesController } from './taxes.controller';
import { Taxes } from './taxes.entity';
import { TaxesService } from './taxes.service';

@Module({
  imports: [
    
    TypeOrmModule.forFeature([Taxes]),
    // forwardRef(() => ClusterModule),
  ],
  controllers: [TaxesController],
  providers: [TaxesService,TaxesAdapter,ApplicationExceptionHandler,LogsService]
})
export class TaxesModule {}
